import { Spin, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import classNames from 'classnames';

import SearchResultCard from '../../pages/Search/components/SearchResultCard';
import { formatNumber } from '../../utils/format';

const { Text } = Typography;

/**
 * Dropdown نتایج جستجوی سریع هدر.
 */
const QuickSearchDropdown = ({
  open,
  loading,
  error,
  query,
  items,
  totalCount,
  onViewAll,
  onSelectResult,
}) => {
  if (!open) return null;

  const trimmed = String(query || '').trim();
  const showHint = trimmed.length > 0 && trimmed.length < 2;
  const showEmpty = !loading && !error && !showHint && items.length === 0 && trimmed.length >= 2;
  const showResults = !loading && !error && items.length > 0;

  return (
    <div
      className={classNames(
        'quick-search-dropdown',
        'absolute left-0 right-0 top-[calc(100%+6px)] z-50 overflow-hidden',
        'rounded-xl border border-slate-200 bg-white shadow-lg',
        'dark:border-white/10 dark:bg-[var(--color-surface)] dark:shadow-black/40',
      )}
      role="listbox"
      aria-label="نتایج جستجوی سریع"
      onMouseDown={(e) => e.preventDefault()}
    >
      {loading ? (
        <div className="flex items-center justify-center gap-2 px-4 py-6 text-slate-500 dark:text-slate-400">
          <Spin size="small" />
          <span className="text-xs">در حال جستجو…</span>
        </div>
      ) : null}

      {!loading && error ? (
        <div className="px-4 py-5 text-center text-xs text-rose-600 dark:text-rose-400">
          {error}
        </div>
      ) : null}

      {!loading && !error && showHint ? (
        <div className="px-4 py-5 text-center text-xs text-slate-500 dark:text-slate-400">
          حداقل ۲ کاراکتر وارد کنید.
        </div>
      ) : null}

      {!loading && !error && showEmpty ? (
        <div className="flex flex-col items-center gap-1.5 px-4 py-6 text-center">
          <SearchOutlined className="text-lg text-slate-400 dark:text-slate-500" />
          <Text className="text-xs font-medium text-slate-600 dark:text-slate-300">
            {trimmed ? `نتیجه‌ای برای «${trimmed}» پیدا نشد.` : 'نتیجه‌ای یافت نشد.'}
          </Text>
          <Text className="text-[11px] leading-relaxed text-slate-500 dark:text-slate-400">
            عبارت دیگری امتحان کنید یا «مشاهده همه» را بزنید.
          </Text>
        </div>
      ) : null}

      {showResults ? (
        <div className="max-h-[360px] overflow-y-auto py-1">
          {items.map(({ type, item }) => (
            <SearchResultCard
              key={`${type}-${item?.id || item?.title || item?.name}`}
              type={type}
              item={item}
              compact
              onSelect={onSelectResult}
            />
          ))}
        </div>
      ) : null}

      {!loading && !error && trimmed.length >= 2 ? (
        <button
          type="button"
          className={classNames(
            'flex w-full items-center justify-center border-0 border-t border-slate-100 bg-slate-50/80 px-3 py-2.5',
            'text-xs font-medium text-brand-600 transition-colors',
            'hover:bg-brand-50 dark:border-white/10 dark:bg-white/[0.03] dark:text-brand-400 dark:hover:bg-brand-500/10',
          )}
          onClick={onViewAll}
        >
          {totalCount > 0
            ? `مشاهده همهٔ ${formatNumber(totalCount)} نتیجه`
            : 'مشاهده همهٔ نتایج'}
        </button>
      ) : null}
    </div>
  );
};

export default QuickSearchDropdown;
